import { CardSuit } from "../card/Card";
import { PopupBiddingChoiceType } from "../popup/PopupBiddingTakeSuit";

export function PopupBiddingChoiceTypeToCardSuit(choiceType: PopupBiddingChoiceType): CardSuit | null {
    switch (choiceType) {
        case PopupBiddingChoiceType.CLUBS:
            return CardSuit.CLUBS;
        case PopupBiddingChoiceType.DIAMONDS:
            return CardSuit.DIAMONDS;
        case PopupBiddingChoiceType.HEARTS:
            return CardSuit.HEARTS;
        case PopupBiddingChoiceType.SPADES:
            return CardSuit.SPADES;
    }
    // console.log("ERROR: has no CardSuit representation:",PopupBiddingChoiceType[choiceType]);
    return null;
}